import styled from '@emotion/styled';
import { css } from '@emotion/react';

const ModalGalleryContainer = styled('div')(
    ({ theme }) => css`
        position: relative;
        width: 100%;
        margin: ${theme.spacing['16px']} auto;
    `
);

const EnergyPerfCertExternalList = styled('ul')(
    ({ theme }) => css`
        width: 100%;
        margin: ${theme.spacing['16px']};
        padding: 0;
        list-style: none;

        ${theme.mq.medium} {
            position: absolute;
            top: 50%;
            left: 50%;
            width: 40%;
            transform: translate(-50%, -50%);
        }
    `
);

const EnergyPerfCertExternalItem = styled('li')(
    ({ theme }) => css`
        margin-bottom: ${theme.spacing['16px']};
    `
);

export {
    ModalGalleryContainer,
    EnergyPerfCertExternalList,
    EnergyPerfCertExternalItem
};
